import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import VendorsPage       from './pages/VendorsPage';
import DashboardPage     from './pages/DashboardPage';
import ContractsPage     from './pages/ContractsPage';
import BillingPage       from './pages/BillingPage';
import ReportsPage       from './pages/ReportsPage';
import NotificationsPage from './pages/NotificationsPage';

function AppRoutes() {
  const { account } = useAuth();

  if (!account) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb', fontFamily: "'Segoe UI', Arial, sans-serif" }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🌲</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1a5c2a', marginBottom: 4 }}>Christmas Lumber</h1>
          <p style={{ color: '#6b7280', marginBottom: 24 }}>Vendor Management</p>
          <LoginButton />
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        {/* Root MUST be vendor list — LEAD iframe loads this path */}
        <Route path="/"              element={<VendorsPage />} />
        <Route path="/dashboard"     element={<DashboardPage />} />
        <Route path="/contracts"     element={<ContractsPage />} />
        <Route path="/billing"       element={<BillingPage />} />
        <Route path="/reports"       element={<ReportsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="*"              element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function LoginButton() {
  const { login } = useAuth();
  return (
    <button
      onClick={login}
      style={{ background: '#1a5c2a', color: 'white', border: 'none', padding: '12px 28px', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
    >
      Sign in with Microsoft 365
    </button>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
